"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AB_EXPERIMENTS_ABAC_FEATURE = exports.AB_EXPERIMENTS_SCOPE = exports.USER_DATA_PERMISSIONS = exports.USER_PERMISSIONS = exports.REFRESH_PERMISSIONS = exports.FETCH_PERMISSIONS = exports.USER_SEND_CODE_LOADING = exports.USER_DATA_LOADING = exports.FETCH_USER_DATA = exports.USER_DATA = exports.CRITICAL_ACTION_ERROR = exports.INCORRECT_CODE = exports.CRITICAL_ACTION_CODE = exports.USER_CRITICAL_ACTION = exports.AUTHENTIFICATE_USER_STATE = void 0;
exports.AUTHENTIFICATE_USER_STATE = 'authentificate-user-state';
exports.USER_CRITICAL_ACTION = 'user-critical-action';
exports.CRITICAL_ACTION_CODE = 'critical-action-code';
exports.INCORRECT_CODE = 'critical-action-incorrect-code';
exports.CRITICAL_ACTION_ERROR = 'critical-action-error';
exports.USER_DATA = 'user-data';
exports.FETCH_USER_DATA = 'fetch-user-data';
exports.USER_DATA_LOADING = 'user-data-loading';
exports.USER_SEND_CODE_LOADING = 'user-send-code-loading';
exports.FETCH_PERMISSIONS = 'fetch-permissions';
exports.REFRESH_PERMISSIONS = 'refresh-permissions';
exports.USER_PERMISSIONS = 'userPermissions';
exports.USER_DATA_PERMISSIONS = 'userDataPermissions';
exports.AB_EXPERIMENTS_SCOPE = 'groups';
exports.AB_EXPERIMENTS_ABAC_FEATURE = 'distributionABv2';
